import React from 'react';
import {Coordinates} from '../types/device.types';

/**
 * Returns the viewport coordinates for a given event.
 *
 * For mouse events, it returns the click position, while for non-mouse events (e.g. keyboard), it returns the center
 * of the event's current target element.
 *
 * @param {React.UIEvent} event The event.
 * @return {Coordinates} The viewport coordinates for the event.
 */
export function getViewportCoordinatesForEvent(event: React.UIEvent): Coordinates {
  // Open popup menu at click position for mouse events
  if (event.nativeEvent instanceof MouseEvent) {
    return {
      x: event.nativeEvent.pageX,
      y: event.nativeEvent.pageY
    }
  }

  // Open popup menu at center of the item for non-mouse events (e.g. keyboard)
  else {
    const rect = event.currentTarget.getBoundingClientRect();
    return {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2
    };
  }
}
